import React from "react";
import { Box, Container, Grid, Typography, Link } from "@mui/material";
import logo from "../../assets/images/smalllogo.png"; // Adjust the path as necessary
import { LinkedIn, Instagram, YouTube } from "@mui/icons-material";
import { publicFooterLinks } from "./publicLinks";
export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: "#f8f8f8", py: 4 }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={6} textAlign={{ xs: "center", md: "left" }}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems={{ xs: "center", md: "flex-start" }}
              textAlign={{ xs: "center", md: "left" }}
            >
              <Box display="flex" alignItems="center" mb={1}>
                <img
                  src={logo} // make sure logo is imported or defined
                  alt="Digital Hive Logo"
                  style={{ height: 40, marginRight: 8 }}
                />
              </Box>

              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ mb: 1 }}
              >
                SalesHive.cloud is an initiative by Digital Hive, a leading
                provider of innovative digital solutions for businesses.
              </Typography>

              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ mb: 1 }}
              >
                923, Tower B3, Spaze i-Tech Park,
                <br />
                Sector-49, Sohna Road, Gurgaon - 122 018, India
              </Typography>

              <Link
                href="https://www.digitalhive.in/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "inherit",
                  textDecoration: "underline",
                  fontSize: "0.75rem",
                }}
              >
                Visit Digital Hive
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={6} textAlign={{ xs: "center", md: "right" }}>
            <Box
              component="nav"
              aria-label="Footer navigation"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: { xs: "center", md: "flex-end" },
                columnGap: 2,
              }}
            >
              {publicFooterLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  target={link.target}
                  rel={link.target ? "noopener noreferrer" : undefined}
                  sx={{
                    minHeight: 44,
                    display: "inline-flex",
                    alignItems: "center",
                    color: "text.secondary",
                    fontSize: 14,
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
            <Box
              mt={2}
              display="flex"
              justifyContent={{ xs: "center", md: "flex-end" }}
            >
              <Link
                href="https://www.linkedin.com/showcase/saleshivecrm"
                aria-label="SalesHive on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mx: 1, color: "inherit" }}
              >
                <LinkedIn />
              </Link>
              <Link
                href="https://www.instagram.com/saleshivecrm/"
                aria-label="SalesHive on Instagram"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mx: 1, color: "inherit" }}
              >
                <Instagram />
              </Link>
              <Link
                href="https://www.youtube.com/@SalesHive"
                aria-label="SalesHive on YouTube"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ mx: 1, color: "inherit" }}
              >
                <YouTube />
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Box mt={3} textAlign="center">
          <Typography variant="caption" color="textSecondary">
            © {new Date().getFullYear()} SalesHive. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
